import "./contact.css";
import Phone from "../../img/phone.png";
import Email from "../../img/email.png";
import Address from "../../img/address.png";
import { useContext, useRef, useState } from "react";
import emailjs from "emailjs-com";
import { ThemeContext } from "../../context";

const Contact = () => {
  const formRef = useRef();
  const [done, setDone] = useState(false)
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  const handleSubmit = async(e) => {
    e.preventDefault();
    const endpoint = "https://formspree.io/f/mknldqpd";

    const formData = new FormData(e.target);
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      if (response.ok) {
        setDone(true);
      } else {
        console.error("Failed to submit form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
    // emailjs
    //   .sendForm(
    //     "service_rrvnzco",
    //     "template_3v5nih4",
    //     formRef.current,
    //     "user_DrriDPTGKO2Zj4RDXCA6W"
    //   )
    //   .then(
    //     (result) => {
    //       console.log(result.text);
    //       setDone(true)
    //     },
    //     (error) => {
    //       console.log(error.text);
    //     }
    //   );
  };

  return (
    <div className="c">
      <div className="c-bg"></div>
      <div className="c-wrapper">
        <div className="c-left">
          <h1 className="c-title">Let's discuss your project</h1>
          <div className="c-info">
            <div className="c-info-item">
              <img src={Phone} alt="" className="c-icon" />
              +91-91-3134-41-98
            </div>
            <div className="c-info-item">
              <img className="c-icon" src={Email} alt="" />
              bhavinpun1@gmail.com
            </div>
            {/* <div className="c-info-item">
              <img className="c-icon" src={Address} alt="" />
              106,kailash chhaya apt, nutan nagar, vapi, Gujarata.
            </div> */}
          </div>
        </div>
        <div className="c-right">
          <p className="c-desc">
            <b>What’s your story?</b> Get in touch. Always available for
            freelancing if the right project comes along. me.
          </p>
          <form ref={formRef} onSubmit={handleSubmit}>
            <input style={{backgroundColor: darkMode && "#333",color: darkMode && "#fff"}} type="text" placeholder="Name" name="user_name" />
            <input style={{backgroundColor: darkMode && "#333",color:darkMode && "#fff"}} type="text" placeholder="Subject" name="user_subject" />
            <input style={{backgroundColor: darkMode && "#333" ,color:darkMode && "#fff"}} type="text" placeholder="Email" name="user_email" />
            <textarea style={{backgroundColor: darkMode && "#333" ,color:darkMode && "#fff"}} rows="5" placeholder="Message" name="message" />
            <button>Submit</button> <br />
            {done && "Thank you!, your message has been received at bhavinpun1@gmail.com"}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
